import { trigger } from '@angular/animations';
import {Questions} from '../common-class/questions';

export class SurveyQuestionAnswerDisplayLogic {

ShowHideQuestion(Question:Questions, ruleValue: any, currValue:any, SourveValueID: number, Operator:string)
{
    let Qtype = this.GetSourceQuestionType(Question);

    currValue = Question.AnswerText == null ? "" : Question.AnswerText;

    if (Question.isCQHide && !Question.InlineQDL && !Question.isSQ ||
        Question.isCQHide && !Question.InlineQDL && Operator != "NOT" && (Question.population_type == 1 || Question.population_type == 3)) {
        return false;
    } else if (Question.isCQHide && Operator == "NOT" && !Question.InlineQDL && (Question.population_type == 1 || Question.population_type == 3)) {
        return true;
    } else if (Question.isCQHide && Question.InlineQDL && Question.isSQ &&
         !Question.isLoading &&  (Question.population_type == 1 || Question.population_type == 3)){

        if (Operator == 'EQUAL') {
            return false;
        } else if (Operator == 'NOTEQUAL') {
            return true;
        }
    }

    if(Operator == 'ISANSWERED')
    {
        if(Qtype =="RK" || Qtype =="NA")
        {
            if(Question.selectedOptionList != undefined && Question.selectedOptionList != null &&  Question.selectedOptionList.length > 0 )
            {
                if(Question.selectedOptionList.filter(e=> e.value_id == SourveValueID && e.value_text != null && e.value_text != "").length > 0)
                {
                    return true;

                }
                else
                    return false;
            }
            else if (Qtype =="NA" && (Question.qsubtype == 21 || Question.qsubtype== 41) && ((currValue != undefined && currValue != '') || Question.selectAnsValue > 0))
            {
                return true;
            }
            else{
                return false;
            }
                
        }
        else if((currValue != undefined && currValue != '') || Question.selectAnsValue > 0)
        {
            return true;
        }
    }
    if(Operator == 'ISNOTANSWERED')
    {
        if((Qtype =="RK" || Qtype =="NA") && (Question.selectedOptionList != undefined && Question.selectedOptionList != null &&  Question.selectedOptionList.length > 0 ))
        {
            if(Qtype =="RK"  && Question.selectedOptionList.filter(e=> e.value_id == SourveValueID).length == 0)
            {
                return true;
            }
            else if(Qtype =="NA"  && Question.selectedOptionList.filter(e=> e.value_id == SourveValueID && (e.value_text == null || e.value_text== "")).length > 0)
            {
                return true;
            }
            else
                return false;
        }
        else if((currValue == undefined || currValue == '') && (Question.selectAnsValue == undefined || Question.selectAnsValue == 0 || Question.selectAnsValue == -1))
        {
        return true;
        }
    }

    let isConditionSatisfied: boolean = false;
    if (Qtype == "D" || Qtype == "T" || Qtype == "T_PHONE"
    || Qtype == "NA" || Qtype == "T_CURRENCY"
    || Qtype == "DL" || Qtype == "GQ" || Qtype == "RK") {

        if((Qtype =="RK" || Qtype =="NA") && Question.selectedOptionList != undefined 
        && Question.selectedOptionList != null &&  Question.selectedOptionList.length > 0 )
        {
            if(Question.selectedOptionList.filter(e=> e.value_id == SourveValueID).length > 0)
            {
                currValue = Question.selectedOptionList.filter(e=> e.value_id == SourveValueID)[0].value_text;
            }
        }

        switch (Operator) {
            case "EQUAL":
                isConditionSatisfied = this.isEQUAL(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;

            case "LESS":
                isConditionSatisfied = this.isLESS(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;

            case "LESSOREQUAL":
                isConditionSatisfied = this.isLESSOREQUAL(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;

            case "GREATER":
                isConditionSatisfied = this.isGREATER(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;

            case "GREATEROREQUAL":
                isConditionSatisfied = this.isGREATEROREQUAL(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;

            case "NOTEQUAL":
                isConditionSatisfied = this.isNotEQUAL(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;

            case "BETWEEN":
                isConditionSatisfied = this.isBETWEEN(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;
            case "NOTBETWEEN":
                isConditionSatisfied = this.isNOTBETWEEN(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;
            case "STARTSWITH":
                isConditionSatisfied = this.isSTARTSWITH(Question, ruleValue,currValue,Qtype,SourveValueID)
                break;

            default:
                isConditionSatisfied = false;
        }
    }
    else{
        switch (Operator) {
            case "AND":
                isConditionSatisfied = this.ValidateANDCondition(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;

            case "OR":
                isConditionSatisfied = this.ValidateORCondition(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;

            case "NOT":
                isConditionSatisfied = this.ValidateNOTCondition(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;

            default:
                isConditionSatisfied = false;
        }
    }
    return isConditionSatisfied;
}

ShowHideContact( DataType :string, ruleValue: any, currValue:any, SourveValueID: number, Operator:string)
{
    let Qtype =DataType; //this.GetSourceQuestionType(Question);

    //currValue = Question.AnswerText == null ? "" : Question.AnswerText;

    // if (Question.isCQHide && !Question.InlineQDL && !Question.isSQ ||
    //     Question.isCQHide && !Question.InlineQDL && Operator != "NOT" && (Question.population_type == 1 || Question.population_type == 3)) {
    //     return false;
    // } else if (Question.isCQHide && Operator == "NOT" && !Question.InlineQDL && (Question.population_type == 1 || Question.population_type == 3)) {
    //     return true;
    // } else if (Question.isCQHide && Question.InlineQDL && Question.isSQ &&
    //      !Question.isLoading &&  (Question.population_type == 1 || Question.population_type == 3)){

    //     if (Operator == 'EQUAL') {
    //         return false;
    //     } else if (Operator == 'NOTEQUAL') {
    //         return true;
    //     }
    // }

    // if(Operator == 'ISANSWERED')
    // {
    //     if(Qtype =="RK" || Qtype =="NA")
    //     {
    //         if(Question.selectedOptionList != undefined && Question.selectedOptionList != null &&  Question.selectedOptionList.length > 0 )
    //         {
    //             if(Question.selectedOptionList.filter(e=> e.value_id == SourveValueID && e.value_text != null && e.value_text != "").length > 0)
    //             {
    //                 return true;

    //             }
    //             else
    //                 return false;
    //         }
    //         else{
    //             return false;
    //         }
                
    //     }
    //     else if((currValue != undefined && currValue != '') || Question.selectAnsValue > 0)
    //     {
    //         return true;
    //     }
    // }
    // if(Operator == 'ISNOTANSWERED')
    // {
    //     if((Qtype =="RK" || Qtype =="NA") && (Question.selectedOptionList != undefined && Question.selectedOptionList != null &&  Question.selectedOptionList.length > 0 ))
    //     {
    //         if(Qtype =="RK"  && Question.selectedOptionList.filter(e=> e.value_id == SourveValueID).length == 0)
    //         {
    //             return true;
    //         }
    //         else if(Qtype =="NA"  && Question.selectedOptionList.filter(e=> e.value_id == SourveValueID && (e.value_text == null || e.value_text== "")).length > 0)
    //         {
    //             return true;
    //         }
    //         else
    //             return false;
    //     }
    //     else if((currValue == undefined || currValue == '') && (Question.selectAnsValue == undefined || Question.selectAnsValue == 0 || Question.selectAnsValue == -1))
    //     {
    //     return true;
    //     }
    // }

    let isConditionSatisfied: boolean = false;
    if (Qtype) {
        switch (Operator) {
            case "EQUAL":
                isConditionSatisfied = this.isEQUAL(null, ruleValue,currValue,Qtype,SourveValueID);
                break;
            case "LESS":
                isConditionSatisfied = this.isLESS(null, ruleValue,currValue,Qtype,SourveValueID);
                break;
            case "LESSOREQUAL":
                isConditionSatisfied = this.isLESSOREQUAL(null, ruleValue,currValue,Qtype,SourveValueID);
                break;
            case "GREATER":
                isConditionSatisfied = this.isGREATER(null, ruleValue,currValue,Qtype,SourveValueID);
                break;
            case "GREATEROREQUAL":
                isConditionSatisfied = this.isGREATEROREQUAL(null, ruleValue,currValue,Qtype,SourveValueID);
                break;
            case "NOTEQUAL":
                isConditionSatisfied = this.isNotEQUAL(null, ruleValue,currValue,Qtype,SourveValueID);
                break;
            case "BETWEEN":
                isConditionSatisfied = this.isBETWEEN(null, ruleValue,currValue,Qtype,SourveValueID);
                break;
            case "NOTBETWEEN":
                isConditionSatisfied = this.isNOTBETWEEN(null, ruleValue,currValue,Qtype,SourveValueID);
                break;
            case "STARTSWITH":
                isConditionSatisfied = this.isSTARTSWITH(null, ruleValue,currValue,Qtype,SourveValueID)
                break;
            case "AND":
                isConditionSatisfied = this.ValidateANDCondition(null, ruleValue,currValue,Qtype,SourveValueID);
                break;
            case "OR":
                isConditionSatisfied = this.ValidateORCondition(null, ruleValue,currValue,Qtype,SourveValueID);
                break;
            case "NOT":
                isConditionSatisfied = this.ValidateNOTCondition(null, ruleValue,currValue,Qtype,SourveValueID);
                break;
            default:
                isConditionSatisfied = false;
        }
    }
    return isConditionSatisfied;
}



ShowHideAnswers(Question:Questions, ruleValue: any, currValue:any, SourveValueID: number, Operator:string)
{
    let Qtype = this.GetSourceQuestionType(Question);

    currValue = Question.AnswerText == null ? "" : Question.AnswerText;

    if (Question.isCQHide && !Question.InlineQDL && !Question.isSQ ||
        Question.isCQHide && !Question.InlineQDL && Operator != "NOT" && (Question.population_type == 1 || Question.population_type == 3)) {
        return false;
    } else if (Question.isCQHide && Operator == "NOT" && !Question.InlineQDL && (Question.population_type == 1 || Question.population_type == 3)) {
        return true;
    } else if (Question.isCQHide && Question.InlineQDL && Question.isSQ &&
         !Question.isLoading &&  (Question.population_type == 1 || Question.population_type == 3)){

        if (Operator == 'EQUAL') {
            return false;
        } else if (Operator == 'NOTEQUAL') {
            return true;
        }
    }

    // Comment

    if(Operator == 'ISANSWERED')
    {
        if((Qtype =="RK" || Qtype =="NA"))
        {
            if(Question.selectedOptionList != undefined 
            && Question.selectedOptionList != null &&  Question.selectedOptionList.length > 0 )
                {
                if(Question.selectedOptionList.filter(e=> e.value_id == SourveValueID && e.value_text != null && e.value_text != "").length > 0)
                {
                return true;
                }
                else
                return false;
            }
            else if (Qtype =="NA" && (Question.qsubtype == 21 || Question.qsubtype== 41) && ((currValue != undefined && currValue != '') || Question.selectAnsValue > 0))
                {
                    return true;
                }
            else
            {
                return false;
            }
                
        }
        else if (Qtype =="RS" && Question.selectAnsValue && Question.selectAnsValue > 0)
        {
            return true;
        }
        else if(currValue != undefined && currValue != '')
        {
        return true;
        }
    }
    if(Operator == 'ISNOTANSWERED')
    {
        if((Qtype =="RK" || Qtype =="NA") && (Question.selectedOptionList != undefined && Question.selectedOptionList != null &&  Question.selectedOptionList.length > 0 ))
        {
            if(Qtype =="RK"  && Question.selectedOptionList.filter(e=> e.value_id == SourveValueID).length == 0)
            {
                return true;
            }
            else if(Qtype =="NA"  && Question.selectedOptionList.filter(e=> e.value_id == SourveValueID && (e.value_text == null || e.value_text== "")).length > 0)
            {
                return true;
            }
            else
                return false;
        }
        else if (Qtype =="RS")
        {
            if(!Question.selectAnsValue)
                 return true;
            else
                return false;
        }
        else if((currValue == undefined || currValue == ''))
        {
        return true;
        }
    }

    let isConditionSatisfied: boolean = false;
    if (Qtype == "D" || Qtype == "T" || Qtype == "T_PHONE"
    || Qtype == "NA" || Qtype == "T_CURRENCY"
    || Qtype == "DL" || Qtype == "GQ" || Qtype == "RK") {

        if((Qtype =="RK" || Qtype =="NA") && Question.selectedOptionList != undefined 
        && Question.selectedOptionList != null &&  Question.selectedOptionList.length > 0 )
        {
            if(Question.selectedOptionList.filter(e=> e.value_id == SourveValueID).length > 0)
            {
                currValue = Question.selectedOptionList.filter(e=> e.value_id == SourveValueID)[0].value_text;
            }
        }

        switch (Operator) {
            case "EQUAL":
                isConditionSatisfied = this.isEQUAL(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;

            case "LESS":
                isConditionSatisfied = this.isLESS(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;

            case "LESSOREQUAL":
                isConditionSatisfied = this.isLESSOREQUAL(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;

            case "GREATER":
                isConditionSatisfied = this.isGREATER(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;

            case "GREATEROREQUAL":
                isConditionSatisfied = this.isGREATEROREQUAL(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;

            case "NOTEQUAL":
                isConditionSatisfied = this.isNotEQUAL(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;

            case "BETWEEN":
                isConditionSatisfied = this.isBETWEEN(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;
            case "NOTBETWEEN":
                isConditionSatisfied = this.isNOTBETWEEN(Question, ruleValue,currValue,Qtype,SourveValueID);
                break;
            case "STARTSWITH":
                isConditionSatisfied = this.isSTARTSWITH(Question, ruleValue,currValue,Qtype,SourveValueID)
                break;


            default:
                isConditionSatisfied = false;
        }
    }
    else{
        switch (Operator) {
            case "AND":
                isConditionSatisfied = this.ValidateANDCondition(Question, ruleValue, currValue, Qtype, SourveValueID,true);
                break;

            case "OR":
                isConditionSatisfied = this.ValidateORCondition(Question, ruleValue, currValue, Qtype, SourveValueID,true);
                break;

            case "NOT":
                isConditionSatisfied = this.ValidateNOTCondition(Question, ruleValue, currValue, Qtype, SourveValueID);
                break;
            case "LESS":
                isConditionSatisfied = this.isLESS(Question, ruleValue, currValue, Qtype, SourveValueID);
                break;
            case "GREATER":
                isConditionSatisfied = this.isGREATER(Question, ruleValue, currValue, Qtype, SourveValueID);
                break;
            case "LESSOREQUAL":
                isConditionSatisfied = this.isLESSOREQUAL(Question, ruleValue, currValue, Qtype, SourveValueID);
                break;
            case "GREATEROREQUAL":
                isConditionSatisfied = this.isGREATEROREQUAL(Question, ruleValue, currValue, Qtype, SourveValueID);
                break;
            case "BETWEEN":
                isConditionSatisfied = this.isBETWEEN(Question, ruleValue, currValue, Qtype, SourveValueID);
                break;
            case "NOTBETWEEN":
                isConditionSatisfied = this.isNOTBETWEEN(Question, ruleValue, currValue, Qtype, SourveValueID);
                break;

            default:
                isConditionSatisfied = false;
        }
    }
    return isConditionSatisfied;
}



//Check if Source Input EQUALs to Condition.
    isEQUAL(Question : Questions,ruleValue: any,currValue: any,Qtype: String,SourveValueID:number) {
    let blnEQUAL, valueAnswer;
    let Type =  Qtype;
    let qSubType = Question ? Question.qsubtype : " ";
    let Condition = ruleValue;
    blnEQUAL = false;

    //if(Type != "DL") {  valueAnswer  = document.getElementById(SQId).value;     }
    if (Type != "DL") {
        if (Question)
            valueAnswer = currValue;
        else
            valueAnswer = ""
    }
    if (Type == "D" || Type == "DL") {
        if (Type == "DL" || qSubType == 2) { valueAnswer = currValue; }

        if (Type == "D" && qSubType == 2 || (Type == "DL" && qSubType == 4) && currValue != null &&
            currValue != "" && currValue != undefined) {
            var dateParts = currValue.split("/");
            valueAnswer = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        }
        if (this.IsDateEqual(valueAnswer, Condition)) { blnEQUAL = true; }
    }
    else {
        if (Type == "T" || Type == "T_PHONE") {
            var strMatch =  valueAnswer.toLowerCase();
            var ConditionMatch = Condition;

            if (Type == "T_PHONE") {
                strMatch = strMatch.replace('(', '');
                strMatch = strMatch.replace(')', '');
                strMatch = strMatch.replace(' ', '');
                //strMatch = strMatch.replace('-','');32405
                strMatch = strMatch.replace(/-/g, '');

                ConditionMatch = ConditionMatch.replace('(', '');
                ConditionMatch = ConditionMatch.replace(')', '');
                ConditionMatch = ConditionMatch.replace(' ', '');
                ConditionMatch = ConditionMatch.replace(/-/g, '');

                Condition = ConditionMatch;
            }
            //26453
            //if(strMatch.match(Condition.toLowerCase()) == Condition.toLowerCase()){  blnEQUAL = true;  }
            try {
                if (strMatch.match(Condition.toLowerCase()) == Condition.toLowerCase()) {
                    blnEQUAL = true;
                }
                else if (!blnEQUAL) {
                    if (strMatch.toLowerCase().indexOf(Condition.toLowerCase()) > -1) {
                        blnEQUAL = true;
                    }
                }
            }
            catch (ex) {
                if (strMatch.toLowerCase().indexOf(Condition.toLowerCase()) > -1) {
                    blnEQUAL = true;
                }
                else {
                    if (valueAnswer.toLowerCase().toString() == Condition.toLowerCase().toString()) { blnEQUAL = true; }
                }
            }
        }
        else if (Type == "GQ") {
            blnEQUAL = (Question.selectAnsValue && Question.selectAnsValue == parseInt(Condition)) ? true : false;
        }
        else if(Type.toLowerCase() == "string" || Type.toLowerCase() =="number" || Type.toLowerCase() =="email" || Type.toLowerCase() =="phone" ||
        Type.toLowerCase() =="url" || Type.toLowerCase() =="date" || Type.toLowerCase() =="time" || Type.toLowerCase() =="date-time")
        {
            strMatch = currValue == null || currValue == undefined ? "" : currValue ;
            Condition = ruleValue;
            if(Type.toLowerCase() =="date" || Type.toLowerCase() =="date-time")
            {
                var dateParts = ruleValue.split("/");
                 Condition = dateParts[1]+"/"+ dateParts[0]+"/"+dateParts[2];     
            }
                try {
                    if (strMatch.match(Condition.toLowerCase()) == Condition.toLowerCase()) {
                        blnEQUAL = true;
                    }
                    else if (!blnEQUAL) {
                        if (strMatch.toLowerCase().indexOf(Condition.toLowerCase()) > -1) {
                            blnEQUAL = true;
                        }
                    }
                }
                catch (ex) {
                    if (strMatch.toLowerCase().indexOf(Condition.toLowerCase()) > -1) {
                        blnEQUAL = true;
                    }
                    else {
                        if (valueAnswer.toLowerCase().toString() == Condition.toLowerCase().toString()) { blnEQUAL = true; }
                    }
                }
        }
        else {
            if (Type == "T_CURRENCY") {
                //if(Type == "T_CURRENCY") { '30746
                valueAnswer = valueAnswer.replace(/\,/gi, "");
                //}

            }
            else if (Type =="NA" && Question.selectedOptionList != undefined && Question.selectedOptionList.length > 0)
            {
                let NASourceID = Question.selectedOptionList.filter(
                    e => e.value_id == SourveValueID);
                    if(NASourceID && NASourceID.length > 0)
                        valueAnswer = parseInt(NASourceID[0].value_text);
            }
            Condition = parseFloat(Condition);
            if (valueAnswer.toString() == Condition.toString()) { blnEQUAL = true; }
        }
    }
    if (blnEQUAL) {
        if (Question) {
            if (Question.isCQHide == true && !Question.InlineQDL
                && (Question.selectedOptionList.length> 0
                    || Question.selectedOptionList
                    || Question.AnswerText)) {
                        blnEQUAL = false;
            }
        }
    }
    return blnEQUAL;
}

//Check if Source Input Not EQUALs to Condition.
isNotEQUAL(Question : Questions,ruleValue: any,currValue: any,Qtype: String,SourveValueID:number) {
    let blnNotEQUAL, valueAnswer;
    let Type =  Qtype;
    let qSubType = Question ? Question.qsubtype : " ";
    let Condition = ruleValue;
    blnNotEQUAL = true;

    if (Type != "DL") {
        if (Question)
            valueAnswer = currValue;
        else
            valueAnswer = ""
    }
    if (Type == "D" || Type == "DL") {
        if (Type == "DL" || qSubType == 2) { valueAnswer = currValue; }

        if (Type == "D" && qSubType == 2 || (Type == "DL" && qSubType == 4) && currValue != null &&
            currValue != "" && currValue != undefined) {
            var dateParts = currValue.split("/");
            valueAnswer = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        }
        if (this.IsDateEqual(valueAnswer, Condition)) { blnNotEQUAL = false; }
    }
    else {
        if (Type == "T" || Type == "T_PHONE") {
            var strMatch = valueAnswer.toLowerCase();
            var ConditionMatch = Condition
            if (Type == "T_PHONE") {
                strMatch = strMatch.replace('(', '');
                strMatch = strMatch.replace(')', '');
                strMatch = strMatch.replace(' ', '');
                strMatch = strMatch.replace(/-/g, '');

                ConditionMatch = ConditionMatch.replace('(', '');
                ConditionMatch = ConditionMatch.replace(')', '');
                ConditionMatch = ConditionMatch.replace(' ', '');
                ConditionMatch = ConditionMatch.replace(/-/g, '');

                Condition = ConditionMatch;
            }
            try {
                if (strMatch.match(Condition.toLowerCase()) == Condition.toLowerCase()) {
                    blnNotEQUAL = false;
                }
                else if (blnNotEQUAL) {
                    if (strMatch.toLowerCase().indexOf(Condition.toLowerCase()) > -1) {
                        blnNotEQUAL = false;
                    }
                }
            }
            catch (ex) {
                if (strMatch.toLowerCase().indexOf(Condition.toLowerCase()) > -1) {
                    blnNotEQUAL = false;
                }
                else {
                    if (valueAnswer.toLowerCase().toString() == Condition.toLowerCase().toString()) { blnNotEQUAL = false; }
                }
            }
        }
        else if (Type == "GQ") {
            blnNotEQUAL = (Question.selectAnsValue && Question.selectAnsValue.toString() == Condition) ? false : true;
        }
        else if(Type.toLowerCase() == "string" || Type.toLowerCase() =="number" || Type.toLowerCase() =="email" || Type.toLowerCase() =="phone" ||
        Type.toLowerCase() =="url" || Type.toLowerCase() =="date" || Type.toLowerCase() =="time" || Type.toLowerCase() =="date-time")
        {
            strMatch = currValue == null || currValue == undefined ? "" : currValue ;;
            Condition = ruleValue;
            if(Type.toLowerCase() =="date" || Type.toLowerCase() =="date-time")
            {
                var dateParts = ruleValue.split("/");
                 Condition = dateParts[1]+"/"+ dateParts[0]+"/"+dateParts[2];     
            }

            try {
                if (strMatch.match(Condition.toLowerCase()) == Condition.toLowerCase()) {
                    blnNotEQUAL = false;
                }
                else if (blnNotEQUAL) {
                    if (strMatch.toLowerCase().indexOf(Condition.toLowerCase()) > -1) {
                        blnNotEQUAL = false;
                    }
                }
            }
            catch (ex) {
                if (strMatch.toLowerCase().indexOf(Condition.toLowerCase()) > -1) {
                    blnNotEQUAL = false;
                }
                else {
                    if (valueAnswer.toLowerCase().toString() == Condition.toLowerCase().toString()) { blnNotEQUAL = false; }
                }
            }
        }
        else {
            if (Type == "T_CURRENCY") {
                //if(Type == "T_CURRENCY") { '30746
                valueAnswer = valueAnswer.replace(/\,/gi, "");
                //}

            }
            else if ((Type =="NA" || Type =="RK") && Question.selectedOptionList != undefined && Question.selectedOptionList.length > 0)
            {
                let NASourceID = Question.selectedOptionList.filter(
                    e => e.value_id == SourveValueID);
                    if(NASourceID && NASourceID.length > 0)
                        valueAnswer = parseInt(NASourceID[0].value_text);
            }
            Condition = parseFloat(Condition);
            if (valueAnswer == Condition) { blnNotEQUAL = false; }
        }
    }
    if (blnNotEQUAL) {
        if (Question) {
            if (Question.isCQHide == true && !Question.InlineQDL && !Question.isSQ
                && (Question.selectedOptionList.length> 0
                    || Question.selectedOptionList
                    || Question.AnswerText)) {
                        blnNotEQUAL = false;
            }
        }
    }
    return blnNotEQUAL;
}


//Check if Source Input is LESS than Condition.
isLESS(Question : Questions,ruleValue: any,currValue: any,Qtype: String,SourveValueID:number) {
    var blnLESS, valueAnswer;
    let Type =  Qtype;
    let qSubType = Question ? Question.qsubtype : " ";
    let Condition = ruleValue;
    blnLESS = false;

    if (Type != "DL") {
        if (Question)
            valueAnswer = currValue;
        else
            valueAnswer = ""
    }
    if (Type == "D" || Type == "DL") {
        if (Type == "DL" || qSubType == 2) { valueAnswer = currValue; }

        if (Type == "D" && qSubType == 2 || (Type == "DL" && qSubType == 4) && currValue != null &&
            currValue != "" && currValue != undefined) {
            var dateParts = currValue.split("/");
            valueAnswer = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        }
        if (this.IsDateLess(valueAnswer, Condition, qSubType)) { blnLESS = true; }
    }
    else if (Type == "GQ") {
       if(Question.selectAnsValue && Question.selectAnsValue > 0)
       {
        var selectedVal = Question.selectAnsValue;
        if (selectedVal < parseInt(Condition)) { blnLESS = true; }
       }
    }
    else {
        if (Type == "T_CURRENCY" || Type == "T") {
            //if(Type == "T_CURRENCY") { '30746
            valueAnswer = valueAnswer.replace(/\,/gi, "");
            //}
        }
        else if ((Type =="NA"||Type =="RK") && Question.selectedOptionList != undefined && Question.selectedOptionList.length > 0)
        {
            let NASourceID = Question.selectedOptionList.filter(
                e => e.value_id == SourveValueID);
                if(NASourceID && NASourceID.length > 0)
                    valueAnswer = NASourceID[0].value_text;
        }
        Condition = parseFloat(Condition);
        if (valueAnswer < Condition) { blnLESS = true; }
    }
    if ((Type == "NA" || Type == "T_CURRENCY" || Type == "RK") && valueAnswer == "") { blnLESS = false; } //PRT 11260

    if( Type.toLowerCase() =="number")
    {
        blnLESS = false;
        if (parseInt(currValue) < parseInt(Condition)) { blnLESS = true; }
    }
    else if(Type.toLowerCase() =="date" || Type.toLowerCase() =="time" || Type.toLowerCase() =="date-time")
    {
        blnLESS = false;
        var conttype = Type.toLowerCase();
        var contDate;
        if(conttype == "time")
        {
            if(Date.parse('01/01/2011 ' + currValue) < Date.parse('01/01/2011 '+Condition )) {
                blnLESS = true;
            }
        }   
        else
        {
            var dateParts = ruleValue.split("/");
            var date1 =  dateParts[1]+"/"+ dateParts[0]+"/"+dateParts[2];
            if (this.IsDateLess(currValue, date1, 0)) { blnLESS = true; }
        } 
    }
    
  
    if (blnLESS) {
        if (Question) {
            if (Question.isCQHide == true
                && (Question.selectedOptionList.length> 0
                    || Question.selectedOptionList
                    || Question.AnswerText)) {
                        blnLESS = false;
            }
        }
    }
    return blnLESS;
}

//Check if Source Input is LESS than Or Equal to Condition.
isLESSOREQUAL(Question : Questions,ruleValue: any,currValue: any,Qtype: String,SourveValueID:number) {
    var blnLESS, valueAnswer;
    let Type =  Qtype;
    let qSubType = Question ? Question.qsubtype : " ";
    let Condition = ruleValue;
    blnLESS = false;

    if (Type != "DL") {
        if (Question)
            valueAnswer = currValue;
        else
            valueAnswer = ""
    }
    if (Type == "D" || Type == "DL") {
        if (Type == "DL" || qSubType == 2) { valueAnswer = currValue; }

        if (Type == "D" && qSubType == 2 || (Type == "DL" && qSubType == 4) && currValue != null &&
            currValue != "" && currValue != undefined) {
            var dateParts = currValue.split("/");
            valueAnswer = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        }

        if (this.IsDateLess(valueAnswer, Condition, qSubType)) { blnLESS = true; }
    }
    else if (Type == "GQ") {
        if(Question.selectAnsValue && Question.selectAnsValue > 0)
        {
            var selectedVal = Question.selectAnsValue;
            if (selectedVal <= parseInt(Condition)) { blnLESS = true; }
        }
    }
    else {
        if (Type == "T_CURRENCY" || Type == "T") {
            //if(Type == "T_CURRENCY") { '30746
            valueAnswer = valueAnswer.replace(/\,/gi, "");
            //}
        }
        else if ((Type == "NA" || Type == "RK") && Question  && Question.selectedOptionList != undefined && Question.selectedOptionList.length > 0)
        {
            let NASourceID = Question.selectedOptionList.filter(
                e => e.value_id == SourveValueID);
                if(NASourceID && NASourceID.length > 0)
                    valueAnswer = NASourceID[0].value_text;
        }
        Condition = parseFloat(Condition);
        if (valueAnswer <= Condition) { blnLESS = true; }
    }
    if ((Type == "NA" || Type == "T_CURRENCY" || Type == "RK") && valueAnswer == "") { blnLESS = false; } //PRT 11260

        if( Type.toLowerCase() =="number")
        {
            blnLESS = false;
            if (parseInt(currValue) <= parseInt(Condition)) { blnLESS = true; }
        }
        else if(Type.toLowerCase() =="date" || Type.toLowerCase() =="time" || Type.toLowerCase() =="date-time")
        {
            blnLESS = false;
            var conttype = Type.toLowerCase();
            var contDate;
            if(conttype == "time")
            {
                if(Date.parse('01/01/2011 ' + currValue) <= Date.parse('01/01/2011 '+Condition )) {
                    blnLESS = true;
                }
            }   
            else
            {
                var dateParts = ruleValue.split("/");
                var date1 = dateParts[1]+"/"+dateParts[0]+"/"+dateParts[2];
                if(Date.parse(currValue) <= Date.parse(date1)) {
                    blnLESS = true;
                }
            } 
        }

    if (blnLESS) {
        if (Question) {
            if (Question.isCQHide == true
                && (Question.selectedOptionList.length> 0
                    || Question.selectedOptionList
                    || Question.AnswerText)) {
                        blnLESS = false;
            }
        }
    }
    return blnLESS;
}


//Check if Source Input is GREATER than Condition.
isGREATER(Question : Questions,ruleValue: any,currValue: any,Qtype: String,SourveValueID:number) {
    var blnGREATER, valueAnswer;
    let Type =  Qtype;
    let qSubType = Question ? Question.qsubtype : " ";
    let Condition = ruleValue;
    blnGREATER = false;

    if (Type != "DL") {
        if (Question)
            valueAnswer = currValue;
        else
            valueAnswer = ""
    }
    if (Type == "D" || Type == "DL") {
        if (Type == "DL" || qSubType == 2) { valueAnswer = currValue; }

        if (Type == "D" && qSubType == 2 || (Type == "DL" && qSubType == 4) && currValue != null &&
            currValue != "" && currValue != undefined) {
            var dateParts = currValue.split("/");
            valueAnswer = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        }
        if (this.IsDateGreater(valueAnswer, Condition)) { blnGREATER = true; }
    }
    else if (Type == "GQ") {
        if(Question.selectAnsValue && Question.selectAnsValue > 0)
        {
            var selectedVal = Question.selectAnsValue;
            if (selectedVal > parseInt(Condition)) { blnGREATER = true; }
        }
    }
    else {
        if (Type == "T_CURRENCY" || Type == "T") {
            //if(Type == "T_CURRENCY") { '30746
            valueAnswer = valueAnswer.replace(/\,/gi, "");
            //}
        }
        else if ((Type == "NA" || Type == "RK") && Question.selectedOptionList != undefined && Question.selectedOptionList.length > 0)
        {
            let NASourceID = Question.selectedOptionList.filter(
                e => e.value_id == SourveValueID);
                if(NASourceID && NASourceID.length > 0)
                    valueAnswer = NASourceID[0].value_text;
        }
        Condition = parseFloat(Condition);
        if (valueAnswer > Condition) { blnGREATER = true; }
    }

    if( Type.toLowerCase() =="number")
    {
        blnGREATER = false;
        if (parseInt(currValue) > parseInt(Condition)) { blnGREATER = true; }
    }
    else if(Type.toLowerCase() =="date" || Type.toLowerCase() =="time" || Type.toLowerCase() =="date-time")
    {
        blnGREATER = false;
        var conttype = Type.toLowerCase();
        var contDate;
        if(conttype == "time")
        {
            if(Date.parse('01/01/2011 ' + currValue) > Date.parse('01/01/2011 '+Condition )) {
                blnGREATER = true;
            }
        }   
        else
        {
            var dateParts = ruleValue.split("/");
            var date1 = dateParts[1]+"/"+dateParts[0]+"/"+dateParts[2];
            if(Date.parse(currValue) > Date.parse(date1 )) {
                blnGREATER = true;
            }
        } 
    }
    if (blnGREATER) {
        if (Question) {
            if (Question.isCQHide == true
                && (Question.selectedOptionList.length> 0
                    || Question.selectedOptionList
                    || Question.AnswerText)) {
                        blnGREATER = false;
            }
        }
    }
    return blnGREATER;
}

//Check if Source Input is GREATER than Or Equal to Condition.
isGREATEROREQUAL(Question : Questions,ruleValue: any,currValue: any,Qtype: String,SourveValueID:number) {
    var blnGREATER, valueAnswer;
    let Type =  Qtype;
    let qSubType = Question ? Question.qsubtype : " ";
    let Condition = ruleValue;
    blnGREATER = false;

    if (Type != "DL") {
        if (Question)
            valueAnswer = currValue;
        else
            valueAnswer = ""
    }
    if (Type == "D" || Type == "DL") {
        if (Type == "DL" || qSubType == 2) { valueAnswer = currValue; }

        if (Type == "D" && qSubType == 2 || (Type == "DL" && qSubType == 4) && currValue != null &&
            currValue != "" && currValue != undefined) {
            var dateParts = currValue.split("/");
            valueAnswer = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        }

        if (this.IsDateGreater(valueAnswer, Condition)) { blnGREATER = true; }
    }
    else if (Type == "GQ") {
        if(Question.selectAnsValue && Question.selectAnsValue > 0)
        {
            var selectedVal = Question.selectAnsValue;
            if (selectedVal >= parseInt(Condition)) { blnGREATER = true; }
        }
    }
    else {
        if (Type == "T_CURRENCY" || Type == "T") {
            //if(Type == "T_CURRENCY") { '30746
            valueAnswer = valueAnswer.replace(/\,/gi, "");
            //}
        }
        else if ((Type == "NA" || Type == "RK") && Question.selectedOptionList != undefined && Question.selectedOptionList.length > 0)
        {
            let NASourceID = Question.selectedOptionList.filter(
                e => e.value_id == SourveValueID);
                if(NASourceID && NASourceID.length > 0)
                    valueAnswer = NASourceID[0].value_text;
        }
        Condition = parseFloat(Condition);
        if (valueAnswer >= Condition) { blnGREATER = true; }
        if (valueAnswer == "" && Condition == 0) { blnGREATER = false; }
    }

    if( Type.toLowerCase() =="number")
        {
            blnGREATER = false;
            if (parseInt(currValue) >= parseInt(Condition)) { blnGREATER = true; }
        }
        else if(Type.toLowerCase() =="date" || Type.toLowerCase() =="time" || Type.toLowerCase() =="date-time")
        {
            blnGREATER = false;
            var conttype = Type.toLowerCase();
            var contDate;
            if(conttype == "time")
            {
                if(Date.parse('01/01/2011 ' + currValue) >= Date.parse('01/01/2011 '+Condition )) {
                    blnGREATER = true;
                }
            }   
            else
            {
                var dateParts = ruleValue.split("/");
                var date1 = dateParts[1]+"/"+dateParts[0]+"/"+dateParts[2];
                if(Date.parse(currValue) >= Date.parse(date1)) {
                    blnGREATER = true;
                }
            } 
        }

    if (blnGREATER) {
        if (Question) {
            if (Question.isCQHide == true
                && (Question.selectedOptionList.length> 0
                    || Question.selectedOptionList
                    || Question.AnswerText)) {
                        blnGREATER = false;
            }
        }
    }
    return blnGREATER;
}

//Check if Source Input is In Between specified range of Condition.
isBETWEEN(Question : Questions,ruleValue: any,currValue: any,Qtype: String,SourveValueID:number) {
    var blnBETWEEN, valueAnswer, arrCondition;
    let Type =  Qtype;
    let qSubType = Question ? Question.qsubtype : " ";
    let Condition = ruleValue;
    blnBETWEEN = false;
    arrCondition = Condition.split("~");

    if (Type != "DL") {
        if (Question)
            valueAnswer = currValue;
        else
            valueAnswer = ""
    }
    if (Type == "D" || Type == "DL") {
        if (Type == "DL" || qSubType == 2) { valueAnswer = currValue; }

        if (Type == "D" && qSubType == 2 || (Type == "DL" && qSubType == 4) && currValue != null &&
            currValue != "" && currValue != undefined) {
            var dateParts = currValue.split("/");
            valueAnswer = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        }

        if (this.IsDateBetween(valueAnswer, arrCondition[0], arrCondition[1])) { blnBETWEEN = true; }
    }
    else if (Type == "GQ") {
        if(Question.selectAnsValue && Question.selectAnsValue > 0)
        {
            var selectedVal = Question.selectAnsValue;
            if (selectedVal >= parseInt(arrCondition[0]) && selectedVal <= parseInt(arrCondition[1])) { blnBETWEEN = true; }
        }
    }
    else {
        if (Type == "T_CURRENCY" || Type == "T") {
            //if(Type == "T_CURRENCY") { '30746
            valueAnswer = valueAnswer.replace(/\,/gi, "");
            //}
        }
        else if ((Type == "NA" || Type == "RK") && Question.selectedOptionList != undefined && Question.selectedOptionList.length > 0)
        {
            let NASourceID = Question.selectedOptionList.filter(
                e => e.value_id == SourveValueID);
                if(NASourceID && NASourceID.length > 0)
                    valueAnswer = NASourceID[0].value_text;
        }
        Condition = parseFloat(Condition);
        if (valueAnswer >= parseFloat(arrCondition[0]) && valueAnswer <= parseFloat(arrCondition[1])) { blnBETWEEN = true; }
    }
    if ((Type == "NA" || Type == "T_CURRENCY" || Type == "RK") && valueAnswer == "") { blnBETWEEN = false; } //PRT 11260

    if( Type.toLowerCase() =="number")
        {
            blnBETWEEN = false;
            if (currValue >= parseFloat(arrCondition[0]) && currValue <= parseFloat(arrCondition[1])) { blnBETWEEN = true; }
        }
        else if(Type.toLowerCase() =="date" || Type.toLowerCase() =="time" || Type.toLowerCase() =="date-time")
        {
            blnBETWEEN = false;
            var conttype = Type.toLowerCase();
            var contDate;
            if(conttype == "time")
            {
                if(Date.parse('01/01/2011 ' + currValue) >= Date.parse('01/01/2011 '+arrCondition[0] ) && Date.parse('01/01/2011 ' + currValue) <= Date.parse('01/01/2011 '+arrCondition[1] ) ) {
                    blnBETWEEN = true;
                }
            }   
            else
            {
                var dateParts = arrCondition[0].split("/");
                var date1 = dateParts[1]+"/"+dateParts[0]+"/"+dateParts[2];
                var dateParts1 = arrCondition[1].split("/");
                var date2 = dateParts1[1]+"/"+ dateParts1[0]+"/"+dateParts1[2];
                if (this.IsDateBetween(currValue, date1, date2)) { blnBETWEEN = true; }
            } 
        }

    if (blnBETWEEN) {
        if (Question) {
            if (Question.isCQHide == true
                && (Question.selectedOptionList.length> 0
                    || Question.selectedOptionList
                    || Question.AnswerText)) {
                        blnBETWEEN = false;
            }
        }
    }
    return blnBETWEEN;
}


//Check if Source Input is In Between specified range of Condition.
isNOTBETWEEN(Question : Questions,ruleValue: any,currValue: any,Qtype: String,SourveValueID:number) {
    var blnNOTBETWEEN, valueAnswer, arrCondition;
    let Type =  Qtype;
    let qSubType = Question ? Question.qsubtype : " ";
    let Condition = ruleValue;
    blnNOTBETWEEN = false;
    arrCondition = Condition.split("~");

    if (Type != "DL") {
        if (Question)
            valueAnswer = currValue;
        else
            valueAnswer = ""
    }
    if (Type == "D" || Type == "DL") {
        if (Type == "DL" || qSubType == 2) { valueAnswer = currValue; }

        if (Type == "D" && qSubType == 2 || (Type == "DL" && qSubType == 4) && currValue != null &&
            currValue != "" && currValue != undefined) {
            var dateParts = currValue.split("/");
            valueAnswer = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        }

        if (this.IsDateNotBetween(valueAnswer, arrCondition[0], arrCondition[1])) { blnNOTBETWEEN = true; }
    }
    else if (Type == "GQ") {
        if(Question.selectAnsValue && Question.selectAnsValue > 0)
        {
            var selectedVal = Question.selectAnsValue;
            if (selectedVal < parseInt(arrCondition[0]) || selectedVal > parseInt(arrCondition[1])) { blnNOTBETWEEN = true; }
        }
    }
    else {
        if (Type == "T_CURRENCY" || Type == "T") {
            //if(Type == "T_CURRENCY") { '30746
            valueAnswer = valueAnswer.replace(/\,/gi, "");
            //}
        }
        else if ((Type == "NA" || Type == "RK") && Question && Question.selectedOptionList != undefined && Question.selectedOptionList.length > 0)
        {
            let NASourceID = Question.selectedOptionList.filter(
                e => e.value_id == SourveValueID);
                if(NASourceID && NASourceID.length > 0)
                    valueAnswer = NASourceID[0].value_text;
        }
        Condition = parseFloat(Condition);
        if (valueAnswer < parseFloat(arrCondition[0]) || valueAnswer > parseFloat(arrCondition[1]) || valueAnswer=="Selected Answer Option" || valueAnswer == "" ) { blnNOTBETWEEN = true; }
    }
    // if ((Type == "NA" || Type == "T_CURRENCY") && valueAnswer == "") { blnNOTBETWEEN = false; } //PRT 11260
    if( Type.toLowerCase() =="number")
        {
            blnNOTBETWEEN = false;
            if (currValue < parseInt(arrCondition[0]) || currValue > parseInt(arrCondition[1])) { blnNOTBETWEEN = true; }
        }
        else if(Type.toLowerCase() =="date" || Type.toLowerCase() =="time" || Type.toLowerCase() =="date-time")
        {
            blnNOTBETWEEN = false;
            var conttype = Type.toLowerCase();
            var contDate;
            if(conttype == "time")
            {
                if(Date.parse('01/01/2011 ' + currValue) < Date.parse('01/01/2011 '+arrCondition[0] ) || Date.parse('01/01/2011 ' + currValue) > Date.parse('01/01/2011 '+arrCondition[1] ) ) {
                    blnNOTBETWEEN = true;
                }
            }   
            else
            {
                var dateParts = arrCondition[0].split("/");
                var date1 =dateParts[1]+"/"+dateParts[0]+"/"+dateParts[2];
                var dateParts1 = arrCondition[1].split("/");
                var date2 = dateParts1[1]+"/"+dateParts1[0]+"/"+dateParts1[2];
                if (this.IsDateNotBetween(currValue, date1,date2)) { blnNOTBETWEEN = true; }
            } 
        }


    if (blnNOTBETWEEN) {
        if (Question) {
            if (Question.isCQHide == true
                && ( (Question.selectedOptionList && Question.selectedOptionList.length> 0)
                    || Question.selectedOptionList
                    || Question.AnswerText)) {
                        blnNOTBETWEEN = false;
            }
        }
    }
    return blnNOTBETWEEN;
}


//Check if Source Input is GREATER than Or Equal to Condition.
isSTARTSWITH(Question : Questions,ruleValue: any,currValue: any,Qtype: String,SourveValueID:number) {

    let blnSTARTSWITH, valueAnswer;
    let Condition = ruleValue;
    blnSTARTSWITH = false;
   
    if (Qtype == "T") {
        valueAnswer = currValue;
        if (valueAnswer.substring(0, Condition.length) == Condition) {
            blnSTARTSWITH = true;
        }
    } else if (Qtype == "T_PHONE") {
        valueAnswer = currValue.replace("(","").replace(")","").replace("-","");
        if (valueAnswer.substring(0, Condition.length) == Condition) {
            blnSTARTSWITH = true;
        }
    }
   return blnSTARTSWITH;

}

//This function validates AND Condition against Input.
ValidateANDCondition(Question : Questions,ruleValue: any,currValue: number,Qtype: String,SourveValueID:number,isADLcall:boolean=false) {
    var blnValidated, selIndex;
    let Type =  Qtype;
    let qSubType = Question ? Question.qsubtype : " ";
    let arrayID = Question ? Question.selectedOptionList: 0;
    let Condition = ruleValue;
    var arrCondition =  Condition.toString().split(',');
    if (Type == "DD" || Type == "RK") {
        try {
            selIndex =  Type == "DD"? (Question.selectAnsValue == undefined ? "" : Question.selectAnsValue) : arrayID[0].value_id;

        }
        catch (err) {
        }

        if (Type == "RK") {
            if (arrayID == undefined) { selIndex = 0; } else {
                let RKQDL = Question.selectedOptionList.filter(
                    e => e.value_id == SourveValueID);

                if (RKQDL.length > 0) {
                    selIndex = parseInt(RKQDL[0].value_text);
                }
            }
            //arrCondition = this.GetRankID(arrCondition);
        }
        if (this.IsDDInCondition(selIndex, arrCondition, Type)) {
            if (Type == "RK") { blnValidated = true; }
            else if (arrCondition.length == 1) { blnValidated = true; }
            else { blnValidated = false; }
        }
        else { blnValidated = false; }
    }
    else if (Type == "R" || Type == "RS" || Type == "GR") {
        for (var i = 0; i < Question.Answers.length; i++) {
            let answer = Question.Answers[i]
            if (this.IsRadioInCondition(answer.value_id, arrCondition) && (!isADLcall || !answer.isADLHide)) {
                if (answer.selectdId == 1 && answer.ControlAns != null) { blnValidated = true; }
                else
                {
                    if (answer) {
                        if (answer.isHide) {
                            blnValidated = true;
                            if(answer.isQuotaHide)
                            {
                                blnValidated = false;
                                break;
                            }
                           
                        }
                        else {
                            blnValidated = false;
                            break;
                        }
                    }
                    else {
                        blnValidated = false;
                        break;
                    }
                }
            }
        }
    }
    else if (Type == "SC") {
        for (var i = 0; i < Question.Answers.length; i++) {
            let answer = Question.Answers[i];
            if (this.IsRadioInCondition(answer.value_id, arrCondition) && (!isADLcall || !answer.isADLHide)) {
                if (answer.selectdId == 1 && answer.ControlAns  != null ) { blnValidated = true; }
                else
                {
                    if (answer) {
                        if (answer.isHide) {
                             blnValidated = true;
                             if(answer.isQuotaHide)
                             {
                                 blnValidated = false;
                                 break;
                             }
                        }
                        else {
                            blnValidated = false;
                            break;
                        }
                    }
                    else {
                        blnValidated = false;
                        break;
                    }
                }
            }
        }
    }
    return blnValidated;
}


//This function validates OR Condition against Input.
ValidateORCondition(Question : Questions,ruleValue: any,currValue: number,Qtype: String,SourveValueID:number,isADLcall:boolean=false) {
    var blnValidated, selIndex;
    let Type = Qtype;
    let qSubType = Question ? Question.qsubtype : " ";
    let arrayID = Question ? Question.selectedOptionList:0;
    let Condition = ruleValue;
    var arrCondition = Condition.toString().split(',');
    if (Type == "DD") {
        selIndex = Question.selectAnsValue == undefined ? "" : Question.selectAnsValue;


        if (this.IsDDInCondition(selIndex, arrCondition, Type)) {
            if (Question) {
                if (!Question.isCQHide) {
                    blnValidated = true;
                }
                else
                    blnValidated = true;
            }
            else
                blnValidated = true;
        }
        else { blnValidated = false; }
    }
    else if (Type == "R" || Type == "RS" || Type == "GR") {
        for (var i = 0; i < Question.Answers.length; i++) {
            let answer = Question.Answers[i];
            if (this.IsRadioInCondition(answer.value_id, arrCondition) && (!isADLcall || !answer.isADLHide)) {
                if (answer.selectdId == 1 && answer.ControlAns !=null) {
                    blnValidated = true;
                    break;
                }
                else {
                    if (answer) {
                        if (answer.isHide) {
                            if(answer.isQuotaHide)
                            {
                                blnValidated = false;
                            }
                            else
                            {
                                blnValidated = true;
                                break;
                            }
                        }
                    }
                }
            }
        }
    }
    else if (Type == "SC") {
        for (var i = 0; i < Question.Answers.length; i++) {
            let answer = Question.Answers[i];
            if (this.IsRadioInCondition(answer.value_id, arrCondition) && (!isADLcall || !answer.isADLHide)) {
                if (answer.selectdId == 1 && answer.ControlAns != null) {
                    blnValidated = true;
                    break;
                }
                else {
                    if (answer) {
                        if (answer.isHide) {
                            if(answer.isQuotaHide)
                            {
                                blnValidated = false;
                            }
                            {
                                blnValidated = true;
                                break;
                            }
                        }
                    }
                }
            }
        }
    }
    else if(Type.toLowerCase() == "string" || Type.toLowerCase() =="number" || Type.toLowerCase() =="email" || Type.toLowerCase() =="phone" ||
    Type.toLowerCase() =="url" || Type.toLowerCase() =="date" || Type.toLowerCase() =="time" || Type.toLowerCase() =="date-time" || Type.toLowerCase() =="boolean")
    {
        var valueID = currValue;
          
        var contactNot = false;
        for (var j = 0; j < arrCondition.length; j++) {
            valueID = currValue;
                if(Type.toLowerCase() =="date" || Type.toLowerCase() =="date-time")
                {
                    var dateParts = arrCondition[j].split("/");
                    arrCondition[j] = dateParts[1]+"/"+ dateParts[0]+"/"+dateParts[2];     
                }
                if (arrCondition[j] == valueID) { contactNot = true; break;}
            }
            if(contactNot == true)
                {
                    blnValidated = true;
                }
                else
                {
                    blnValidated = false;
                }
    }
    return blnValidated;
}

//This function validates NOT Condition against Input.
ValidateNOTCondition(Question : Questions,ruleValue: any,currValue: number,Qtype: String,SourveValueID:number) {
    var blnValidated, selIndex;
    let Type =  Qtype;
    let qSubType = Question ? Question.qsubtype : " ";
    let arrayID =Question ? Question.selectedOptionList:[];
    let Condition = ruleValue;
    var arrCondition =  Condition.toString().split(',');
    if (Type == "DD" || Type == "RK") {
        selIndex = Type=="DD" ? (Question.selectAnsValue == undefined ? "" : Question.selectAnsValue) :
         arrayID != null && arrayID != undefined && arrayID.length > 0 ? arrayID[0].value_id : 0;
        if (Type == "RK") {
            if (selIndex == 0) { selIndex = 0; } else {
                let RKQDL = Question.selectedOptionList.filter(
                    e => e.value_id == SourveValueID);

                if (RKQDL != undefined && RKQDL.length > 0) {
                    selIndex = RKQDL[0].value_text;
                } else {
                    selIndex = 0;
                }
            }
            arrCondition = this.GetRankID(arrCondition);
        }
        if (this.IsDDInCondition(selIndex, arrCondition, Type)) { blnValidated = false; }
        else { blnValidated = true; }
    }
    else if (Type == "R" || Type == "RS" || Type == "GR") {
        for (var i = 0; i < Question.Answers.length; i++) {
            let answer = Question.Answers[i];
            if (this.IsRadioInCondition(answer.value_id, arrCondition)) {
                if (answer.selectdId == 1 && answer.ControlAns != null) {
                    blnValidated = false;
                    break;
                }
                else {
                    if (answer) {
                        if (answer.isHide) {
                            if(answer.isQuotaHide)
                            {
                                blnValidated = true;
                            }
                            else
                            {
                                blnValidated = false;
                                break;
                            }
                        }
                        else {
                            blnValidated = true;
                        }
                    }
                    else {
                        blnValidated = true;
                    }
                }
            }
            else { blnValidated = true; }
        }
    }
    else if (Type == "SC") {
        for (var i = 0; i < Question.Answers.length; i++) {
            let answer = Question.Answers[i];
            if (this.IsRadioInCondition(answer.value_id, arrCondition)) {
                if (answer.selectdId == 1 && answer.ControlAns != null) {
                    blnValidated = false;
                    break;
                }
                else {
                    if (answer) {
                        if (answer.isHide) {
                            if(answer.isQuotaHide)
                            {
                                blnValidated = true;
                            }
                            else
                            {
                                blnValidated = false;
                                break;
                            }
                        }
                        else {
                            blnValidated = true;
                        }
                    }
                    else {
                        blnValidated = true;
                    }
                }
            }
            else { blnValidated = true; }
        }
    }
    else if(Type.toLowerCase() == "string" || Type.toLowerCase() =="number" || Type.toLowerCase() =="email" || Type.toLowerCase() =="phone" ||
    Type.toLowerCase() =="url" || Type.toLowerCase() =="date" || Type.toLowerCase() =="time" || Type.toLowerCase() =="date-time" || Type.toLowerCase() =="boolean")
    {
        var valueID;
        var contactNot = false;
        for (var j = 0; j < arrCondition.length; j++) {
            valueID = currValue;
            if(Type.toLowerCase() =="date" || Type.toLowerCase() =="date-time")
            {
                var dateParts = arrCondition[j].split("/");
                arrCondition[j] = dateParts[1]+"/"+ dateParts[0]+"/"+dateParts[2];     
            }
            if (arrCondition[j] == valueID) { contactNot = true; break; }
            }
        if(contactNot == false)
            {
                blnValidated = true;
            }
            else
            {
                blnValidated = false;
            }
    }
    return blnValidated;
}

//Check if Date is Greater.
IsDateGreater(DateValue1, DateValue2) {
    var DaysDiff;
    var Date1,Date2;

    Date1 = new Date(DateValue1);
    Date2 = new Date(DateValue2);
    DaysDiff = Math.floor((Date1.getTime() - Date2.getTime()) / (1000 * 60 * 60 * 24));
    if (DaysDiff > 0)
        return true;
    else
        return false;
}

//Check if Date is Less.
IsDateLess(DateValue1, DateValue2, qty) {
    var DaysDiff;
    var Date1,Date2;
    if ((qty == 3 || qty == 4) && DateValue1 == '1/1/1900') {
        return false;
    }
    Date1 = new Date(DateValue1);
    Date2 = new Date(DateValue2);
    DaysDiff = Math.floor((Date1.getTime() - Date2.getTime()) / (1000 * 60 * 60 * 24));
    if (DaysDiff < 0)
        return true;
    else
        return false;
}


//Check if Date is Equal.
IsDateEqual(DateValue1, DateValue2) {
    var DaysDiff;
    var Date1,Date2;
    Date1 = new Date(DateValue1);
    Date2 = new Date(DateValue2);
    DaysDiff = Math.floor((Date1.getTime() - Date2.getTime()) / (1000 * 60 * 60 * 24));
    if (DaysDiff == 0)
        return true;
    else
        return false;
}

//Check if Date is In Between Date2 AND Date3
IsDateBetween(DateValue1, DateValue2, DateValue3) {
    var DaysDiff1, DaysDiff2;
    var Date1,Date2,Date3;

    if (DateValue1 != null && DateValue1 != "" && DateValue1 != undefined) {
    Date1 = new Date(DateValue1);
    } else {
        return false;
    }

    Date2 = new Date(DateValue2);
    Date3 = new Date(DateValue3);

    DaysDiff1 = Math.floor((Date1.getTime() - Date2.getTime()) / (1000 * 60 * 60 * 24));
    DaysDiff2 = Math.floor((Date1.getTime() - Date3.getTime()) / (1000 * 60 * 60 * 24));

    if (DaysDiff1 >= 0 && DaysDiff2 <= 0)
        return true;
    else
        return false;
}

//Check if Date is In Not Between Date2 AND Date3
IsDateNotBetween(DateValue1, DateValue2, DateValue3) {
    var DaysDiff1, DaysDiff2;
    var Date1,Date2,Date3;

    if (DateValue1 != null && DateValue1 != "" && DateValue1 != undefined) {
    Date1 = new Date(DateValue1);
    } else {
        return false;
    }

    Date2 = new Date(DateValue2);
    Date3 = new Date(DateValue3);

    DaysDiff1 = Math.floor((Date1.getTime() - Date2.getTime()) / (1000 * 60 * 60 * 24));
    DaysDiff2 = Math.floor((Date1.getTime() - Date3.getTime()) / (1000 * 60 * 60 * 24));

    if (DaysDiff1 < 0 || DaysDiff2 > 0)
        return true;
    else
        return false;
}

//Is Current Radio Button In Condition
IsRadioInCondition(selectAnsValue: number, arrCondition) {

    var valueID;

    for (var j = 0; j < arrCondition.length; j++) {
        valueID = selectAnsValue;
        //if(parseInt(arrCondition[j]) == valueID) {   return true;    }
        if (isNaN(valueID)) {
            if (parseInt(arrCondition[j]) == 0) { return true; }
        }
        else {
            if (parseInt(arrCondition[j]) == valueID) { return true; }
        }
    }
    return false;
}


//Is Current DropDown In Condition.
    IsDDInCondition(index, arrCondition, Type) {
        if (Type == "RK") {
            if (parseInt(arrCondition) == index) { return true; }
        }
        else {

            for (var j = 0; j < arrCondition.length; j++) {
                if (parseInt(arrCondition[j]) == 0) {
                    if (index == "1999") {
                        return true;
                    }
                }
            }

            for (var j = 0; j < arrCondition.length; j++) {
                if (index.toString() != "" && parseInt(arrCondition[j]) == index) {
                    return true;
                }
            }
        }
        return false;
    }

//Get Rank ID of RANK.
GetRankID(arrCondition) {
    var strSplit = arrCondition[0].split(' ');
     return strSplit[strSplit.length - 1];
}

GetSourceQuestionType(Question:Questions)
{
        let SourceQType:string;

        switch (Question.qtype)
        {
            case "C":
                {
                    SourceQType = "R";
                    break;
                }

            case "L":
            case "GD":
                {
                    SourceQType = "DD";
                    break;
                }

            case "RK":
            case "RS":
                {
                    SourceQType = Question.qtype;
                    break;
                }

            case "ML":
                {
                    SourceQType = "R";
                    break;
                }

            case "CS":
                {
                    SourceQType = "NA";
                    break;
                }

            case "RT":
            case "RW":
                {
                    switch (Question.qsubtype)
                    {
                        case 1:
                            {
                                SourceQType = "GR";
                                break;
                            }

                        case 7:
                            {
                                SourceQType = "R";
                                break;
                            }

                        default:
                            {
                                SourceQType = "DD";
                                break;
                            }
                    }

                    break;
                }

            case "T":
                {
                    let qSubtType = Question.qsubtype;
                    if (qSubtType == 1 || qSubtType == 2)
                        SourceQType = "D";
                    else if (qSubtType == 3 || qSubtType == 4)
                        SourceQType = "DL";
                    else if (qSubtType == 21 || qSubtType == 41)
                        SourceQType = "NA";
                    else if (qSubtType == 61)
                        SourceQType = "T_PHONE";
                    else if (qSubtType == 22)
                        SourceQType = "T_CURRENCY";
                    else
                        SourceQType = "T";
                    break;
                }

            case "SC":
            case "GC":
                {
                    SourceQType = "SC";
                    break;
                }

            case "GR":
                //case "RW":
                {
                    SourceQType = "GR";
                    break;
                }
            //case "RS":
            case "RG":
                {
                    SourceQType = "RS";
                    break;
                }

            case "GQ":
                {
                    SourceQType = "GQ";
                    break;
                }

            default:
                {
                    SourceQType = "R";
                    break;
                }
        }

        return SourceQType;
}

}


